import React, { Component } from 'react'
// import './DoubleOptIn.css'
import Spinner from  '../../components/UI/Spinner/Spinner'
import Container from  '../../components/Container/Container'
import Error from  '../../components/Error/Error'
import axios from '../../axios-instance'
import ReactGA4 from 'react-ga4'

class Unsubscribe extends Component {
	state = {
		copy: {
			headline: 'Newsletter Abmeldung',
			text: 'Schade, dass du gehst! Solltest du es dir anders überlegen, kannst du dich jederzeit wieder anmelden.',
		},
		loading: true,
		errorMessage: ''
	}

	componentDidMount = () => {
		// Google Analytics
		ReactGA4.initialize('G-0Y9M8BCZM7')

		const urlParams = new URLSearchParams(window.location.search);

		this.setState({
					loading: false
				})

		if (urlParams.get('email') === null) { return; }

		const formData = new FormData()
		formData.append('email', urlParams.get('email'))
		formData.append('unsubscribe', urlParams.get('unsubscribe'))

		axios.post( '/newsletterusers', formData )
			.then( response => {
				this.setState({
					loading: false
				})
			})
			.catch( error => {
				this.setState({
					loading: false,
					errorMessage: error.message
				})
			})
	}

	render () {
		if (this.state.errorMessage) {
			return <Error errorMessage={this.state.errorMessage} />
		}

		if (this.state.loading) {
			return <Spinner />
		}

		return (
			<div className='Unsubscribe'>
				<Container>
					<h1 className='text-center'>{this.state.copy.headline}</h1>
					<p className='text-center'>{this.state.copy.text}</p>
				</Container>
			</div>
		)
	}
}

export default Unsubscribe